<template>
  <div class="common-container flex-row">
    <div class="box selected">
      <div class="title">已选应用</div>
      <div class="subtitle"><i class="el-icon-mouse"></i>可通过鼠标拖拽对应用进行排序</div>
      <div class="buttons flex-row">
        <el-button type="primary" icon="el-icon-back" @click="$router.back()">返回</el-button>
        <el-button type="primary" icon="el-icon-finished" @click="save">保存</el-button>
      </div>
      <el-divider></el-divider>
      <ul>
        <li v-for="item in commonAppList" :key="item.idOperation" v-dragging="{ item, list: commonAppList }">
          <div class="info flex-column">
            <img :src="baseUrl + item.opeIcon">
            <span>{{ item.opeName }}</span>
          </div>
          <i class="el-icon-remove" @click="delApp(item.idOperation)"></i>
        </li>
      </ul>
    </div>
    <div class="box unselected">
      <div class="title">添加应用</div>
      <div class="subtitle"><i class="el-icon-star-off"></i>最多添加8个，最少添加1个常用应用，且不可重复添加</div>
      <el-tabs v-model="activeName">
        <el-tab-pane v-for="tab, index in tabList" :label="tab.name" :key="tab.id" :name="'tab' + index">
          <ul>
            <li v-for="item in tab.children" :key="item.id">
              <div class="info flex-column">
                <img :src="baseUrl + item.customIcon">
                <span>{{ item.name }}</span>
              </div>
              <i class="el-icon-circle-plus" @click="addApp(item)"></i>
            </li>
          </ul>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import { getAppListApi, getCommonAppsApi, } from '../../layout/api'
import { saveCommonAppsApi } from './api'
export default {
  name: 'Common',
  data() {
    return {
      baseUrl: localStorage.getItem('baseUrl'),
      commonAppList: [],
      tabList: [],
      activeName: 'tab0'
    }
  },
  async created() {
    const { data: { userOperationList } } = await getAppListApi()
    this.tabList = userOperationList
    const { data: { userCommonAppList } } = await getCommonAppsApi()
    this.commonAppList = userCommonAppList
  },
  methods: {
    addApp(item) {
      if (this.commonAppList.length < 8) {
        const index = this.commonAppList.findIndex(_item => _item.idOperation === item.id)
        if (index === -1) {
          this.commonAppList.push({
            idOperation: item.id,
            opeIcon: item.customIcon,
            opeName: item.name
          })
        } else {
          this.$message.warning('已经添加过【' + item.name + '】应用')
        }
      } else {
        this.$message.warning('最多可添加 8 个应用')
      }
    },
    delApp(id) {
      if (this.commonAppList.length === 1) {
        return this.$message.warning('至少要保留一个应用')
      }
      const index = this.commonAppList.findIndex(item => item.idOperation === id)
      this.commonAppList.splice(index, 1)
    },
    async save() {
      const params = {
        flag: 1,
        operationIdList: this.commonAppList.map(item => item.idOperation)
      }
      await saveCommonAppsApi(params)
      this.$message.success('保存成功')
    }
  }
}
</script>

<style lang="scss" scoped>
.common-container {
  height: 100vh;
  background: no-repeat center/cover url(../../assets/home.png);
  padding: 50px;
  gap: 50px;

  .box {
    height: 100%;
    width: 50%;
    overflow: auto;
    border: 1px solid #eee;
    padding: 30px;
    backdrop-filter: blur(10px);

    .title {
      font-size: 30px;
      color: $titleColor;
    }

    .subtitle {
      font-size: 13px;
      margin-top: 10px;
      color: $contentColor;

      i {
        margin-right: 4px;
      }
    }

    ul {
      margin-top: 20px;
      display: grid;
      grid-template-columns: repeat(auto-fill, 180px);
      gap: 30px;

      li {
        width: 100%;
        border: 1px solid #eee;
        background: #fff;
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
        padding: 15px;
        transition: 300ms;

        &:hover {
          border-color: #C8151D20;
          background: linear-gradient(60deg, #FF676E00, #FF676E20);

          i {
            color: $successColor;
            scale: 1.2;
          }

          .info img {
            scale: 1.1;
          }

          .info span {
            color: $homeRed;
          }
        }

        .info {
          align-items: flex-start;
          gap: 20px;

          img {
            width: 40px;
            height: 40px;
            transition: 300ms;
          }

          span {
            color: $contentColor;
            transition: 300ms;
          }
        }

        i {
          font-size: 20px;
          transition: 300ms;
          cursor: pointer;
          color: $placeColor;
        }
      }
    }

    &.selected {
      .buttons {
        margin: 14px 0 10px;

      }

      .el-divider {
        margin: 0;
        height: 1.5px;
      }

      ul {
        margin-top: 35px;

        li {
          cursor: move;

          &:hover {
            border-style: dashed;

            i {
              color: $dangerColor;
            }
          }
        }
      }
    }

    &.unselected {

      .el-tabs {
        margin-top: 25px;
      }
    }
  }
}

::v-deep .el-tabs {
  &__item.is-active {
    color: $homeRed;
  }

  &__item:hover {
    color: $homeRed;
  }

  &__active-bar {
    background-color: $homeRed;
  }
}


::v-deep .el-button {
  border-radius: 0;

  &--primary {
    background-color: $homeRed;
    border-color: $homeRed;

    &:hover {
      background-color: lighten($homeRed, 5%);
      border-color: lighten($homeRed, 5%);
    }

    &:active {
      background-color: darken($homeRed, 5%);
      border-color: darken($homeRed, 5%);
    }
  }
}
</style>